const ForceUpdateTypes = {
  ANIMALS: "ANLS",
  BUILDINGS: "BUGS",
  DEVICES: "DEES",
  DICTIONARY: "DIRY",
  EVENTS: "EVTS",
  NOTIFICATIONS: "NONS",
  SETTINGS: "SEGS",
  TECHNO_GROUPS: "TEPS",
  USERS: "USRS",
  GROUPS: "GRPS",
  ATHENA: "ATNA",
  SETTLEMENTS: "SETS",
  TRANSLATIONS: "TRNS",
  CHANGE_CLIENT: "CHNT",
  ISSUE_TRACKING_SYSTEM: "ISEM",
  LOGOUT: "LOUT",
  SESSION: "SEON",
  MAINTENANCE: "MACE",
  FILES: "FIES",
  SALES: "SAES",
  ECONOMY: "ECMY",
  PREFERENCES: "PRES",
  SILO: "SILO",
  DOCUMENTS: "DOTS",
  CLIENTS: "CLTS",
  PRESENCE: "PRCE",
  GET_USER: "GUSR",
  PROJECT: "PRCT",
  BREEDING_COUNTERS: "BRCT",
  LICENSE: "LISE",
};

module.exports = ForceUpdateTypes;
